( function ( fnCallback ) {
    'use strict';
    // Custom implementation of jQuery( document ).on( 'ready', function () {} ) to make sure "ready" event on document fires before "load" on window.
    // https://github.com/jquery/jquery/blob/ad6a94c3f1747829082b85fd53ee2efbae879707/src/core/ready.js#L80-L93
    if ( document.readyState === 'complete' || ( document.readyState !== 'loading' && !document.documentElement.doScroll )
    ) {
        fnCallback();
    }
    else {
        document.addEventListener( 'DOMContentLoaded', fnCallback );
    }
}( function () {
    e4.util.debug( 'Event "ready" fired on "document".', e4.settings.debug );
    e4.gtm.init();
    e4.forms.init();
    e4.product.init();
    //e4.productlist.init();
    //e4.download.init();
    //e4.cart.init();
    //e4.checkout.init();
    e4.header.init();
    e4.nav.global.init();
} ) );

